import { render, staticRenderFns } from "./PefDiary.vue?vue&type=template&id=078a704e&"
import script from "./PefDiary.vue?vue&type=script&lang=js&"
export * from "./PefDiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports